import { Component, Input } from '@angular/core';

@Component({
  selector: 'fc-sort-icon',
  template: `
    <fa-icon [icon]="sortIcon"></fa-icon>
  `,
  standalone: false
})
export class FCSortIconComponent {
  @Input() sortBy: any;
  @Input() sortStates: any;
  @Input() column: string;

  get sortIcon() {
    if (this.sortBy instanceof Array) {
      let i = this.sortBy.findIndex(([col]) => col === this.column);
      if (i > -1 && this.sortBy[i][1] === this.sortStates.ascending) {
        return ['fas', 'sort-up'];
      } else if (i > -1 && this.sortBy[i][1] === this.sortStates.descending) {
        return ['fas', 'sort-down'];
      }
    } else if (this.sortBy && this.sortBy[this.column] === this.sortStates.ascending) {
      return ['fas', 'sort-up'];
    } else if (this.sortBy && this.sortBy[this.column] === this.sortStates.descending) {
      return ['fas', 'sort-down'];
    }
    return ['fal', 'sort'];
  }
}
